import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-hero-blue-floatee.component.scss';
import Slider from '../slider/slider.component';
var BannerHeroBlueFloatee = /** @class */ (function (_super) {
    tslib_1.__extends(BannerHeroBlueFloatee, _super);
    function BannerHeroBlueFloatee(element) {
        return _super.call(this, element) || this;
    }
    BannerHeroBlueFloatee.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev
            },
            autoplay: {
                delay: 7000
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    BannerHeroBlueFloatee.prototype.bindEvents = function () { };
    return BannerHeroBlueFloatee;
}(Base));
export { BannerHeroBlueFloatee };



//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-blue-floatee/banner-hero-blue-floatee.component.ts
// module id = 123
// module chunks = 0